import React from 'react'

import {
  FeaturedCarouselType,
  SortOptionType,
  SortOrder,
} from '~/app/common/enums'
import { useTranslation } from '~/app/i18n/client'
import { useItems } from '../hooks/use-items'
import { FeaturedCarousel } from './featured-carousel'

const FeaturedRetailers: React.FC<{ content?: any }> = ({ content }) => {
  const { items, loading } = useItems(
    {
      isFeatured: true,
      isAffiliate: true,
      sort: { by: SortOptionType.CreatedDate, order: SortOrder.Descending },
    },
    1,
    content?.pageSize ? Number(content?.pageSize) : undefined,
  )

  const { t: translate } = useTranslation()

  return (
    <FeaturedCarousel
      type={FeaturedCarouselType.Retailer}
      title={translate('featuredRetailers')}
      helperText={translate('featuredRetailersHelperText')}
      items={items}
      loading={loading}
    />
  )
}

export { FeaturedRetailers }
